import React from 'react';

export const PageNotFound = () => (
    <div style={{display:"flex", height: "90vh", justifyContent: "center", alignItems: "center", gap: "10vw"}}>
        <div style={{display: "inline-block"}}>
            <h1 style={{fontSize: "3em"}}>Page not found</h1>
            <p><b>Sorry, we can't find the page you are looking for.</b></p>
            <p>You may have used an outdated link, or you may have<br/> typed the address incorrectly.</p>
            <p><i>Error code: <span>404</span></i></p>
        </div>
        <div style={{display: "inline-block"}}>
            <img src="/assets/404.svg" height="227px"/>
        </div>
    </div>
)